import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle } from "lucide-react";
import API_URL from "../config";
import { useIdioma } from "../context/IdiomaContext";
import { useEstilo } from "../context/EstiloContext";
import { obtenerEstilo } from "../temas/catalogoEstilos";

const ReservaCita = ({ profesor, horarioSeleccionado, padre, onVolver, onFinalizar, onVerMisCitas, servicioActual }) => {
  const { t, idioma } = useIdioma();
  const estiloGlobal = useEstilo();
  const estilo = servicioActual?.estilo_visual ? obtenerEstilo(servicioActual.estilo_visual) : estiloGlobal;
  const [alumno, setAlumno] = useState("");
  const [grado, setGrado] = useState("");
  const [comentario, setComentario] = useState("");
  const [loading, setLoading] = useState(false);
  const [citaConfirmada, setCitaConfirmada] = useState(false);

  // 🔹 Colores dinámicos según el servicio
  const colorPrincipal = servicioActual?.color || "#38bdf8";

  const localeIntl = idioma === "de" ? "de-DE" : idioma === "en" ? "en-US" : "es-ES";

  const formatHora12 = (horaStr) => {
    const [h, m] = horaStr.split(":");
    let hh = parseInt(h);
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12 || 12;
    return `${hh}:${m} ${ampm}`;
  };


const handleReserva = async () => {

  console.log("👉 PADRE COMPLETO:", padre);
  console.log("👉 EMAIL PADRE:", padre?.email);

  if (!alumno || !grado) {
    Swal.fire(t("reserva_atencion_titulo"), t("reserva_atencion_texto"), "warning");
    return;
  }




    try {
      setLoading(true);
      const res = await axios.post(`${API_URL}/api/citas/reservar`, {
        correo_padre: padre.email,
        id_profesor: profesor.id,
        id_horario: horarioSeleccionado.id,
        alumno_nombre: alumno,
        grado,
        comentario,
      });

      if (res.data.success) setCitaConfirmada(true);
      else Swal.fire(`❌ ${t("reserva_error_titulo")}`, res.data.error || t("reserva_error_texto"), "error");
    } catch (err) {
      console.error(err);
      Swal.fire(`❌ ${t("reserva_error_titulo")}`, err.response?.data?.error || t("reserva_error_texto"), "error");
    } finally {
      setLoading(false);
    }
  };

  if (citaConfirmada) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "transparent",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 20,
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            style={{
              background: "#fff",
              borderRadius: 22,
              padding: 34,
              width: "100%",
              maxWidth: 460,
              textAlign: "center",
              boxShadow: "0 20px 45px rgba(0,0,0,0.2)",
            }}
          >
            <CheckCircle
              size={70}
              color={colorPrincipal}
              style={{ marginBottom: 14 }}
            />

            <h2 style={{ color: colorPrincipal, marginBottom: 6 }}>
              {t("reserva_confirmada_titulo")}
            </h2>

            <p style={{ color: "#475569", marginBottom: 20 }}>
              {t("reserva_confirmada_subtitulo")}
            </p>

            <img
              src={profesor.foto}
              alt={profesor.nombre}
              onError={(e) =>
                (e.currentTarget.src =
                  `${API_URL}/Fotos_profesores/default.png`)
              }
              style={{
                width: 120,
                height: 120,
                borderRadius: "50%",
                objectFit: "cover",
                border: `4px solid ${colorPrincipal}`,
                margin: "0 auto 14px",
                display: "block",
              }}
            />

            <strong style={{ color: "#1e293b" }}>{profesor.nombre}</strong>

            <div
              style={{
                marginTop: 18,
                background: "#f8fafc",
                borderRadius: 14,
                padding: 16,
                textAlign: "left",
                fontSize: 14,
              }}
            >
              <p>
                <strong>{t("reserva_fecha")}</strong>{" "}
                {new Date(horarioSeleccionado.fecha).toLocaleDateString(localeIntl)}
              </p>

              <p>
                <strong>{t("reserva_hora")}</strong>{" "}
                {formatHora12(horarioSeleccionado.hora_inicio)} –{" "}
                {formatHora12(horarioSeleccionado.hora_fin)}
              </p>

              <p>
                <strong>{t("reserva_alumno")}</strong> {alumno}
              </p>

              <p>
                <strong>{t("reserva_grado")}</strong> {grado}
              </p>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                setCitaConfirmada(false);
                if (typeof onFinalizar === "function") onFinalizar();
              }}
              style={
                estilo.botonEstilo === "outline"
                  ? {
                      marginTop: 22,
                      padding: "12px 26px",
                      background: "white",
                      color: colorPrincipal,
                      border: `2px solid ${colorPrincipal}`,
                      borderRadius: estilo.botonRadius,
                      cursor: "pointer",
                      fontSize: 14,
                      width: "100%",
                    }
                  : {
                      marginTop: 22,
                      padding: "12px 26px",
                      backgroundColor: colorPrincipal,
                      color: "#fff",
                      border: "none",
                      borderRadius: estilo.botonRadius,
                      cursor: "pointer",
                      fontSize: 14,
                      width: "100%",
                    }
              }
            >
              {t("reserva_volver_inicio")}
            </motion.button>

            {estilo.misCitasTabs && typeof onVerMisCitas === "function" && (
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  setCitaConfirmada(false);
                  onVerMisCitas();
                }}
                style={{
                  marginTop: 10,
                  padding: "12px 26px",
                  background: "white",
                  color: colorPrincipal,
                  border: `2px solid ${colorPrincipal}`,
                  borderRadius: estilo.botonRadius,
                  cursor: "pointer",
                  fontSize: 14,
                  width: "100%",
                }}
              >
                {t("panel_ver_mis_citas").replace("📋 ", "")}
              </motion.button>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    );
  }

  if (estilo.formDosColumnas) {
    return (
      <motion.div
        className="reserva-dos-columnas"
        initial={{ opacity: 0, y: 25 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        style={{
          minHeight: "100vh",
          background: "transparent",
          fontFamily: "'Poppins', sans-serif",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: 25,
        }}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.35 }}
          style={{
            background: "#fff",
            borderRadius: estilo.cardRadius,
            overflow: "hidden",
            width: "100%",
            maxWidth: 820,
            boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {/* COLUMNA IZQUIERDA — resumen de la cita */}
          <div className="reserva-columna" style={{ flex: "1 1 300px", background: "#f8fafc", padding: 30, textAlign: "center" }}>
            <img
              className="reserva-avatar"
              src={profesor.foto}
              alt={profesor.nombre}
              onError={(e) => (e.currentTarget.src = `${API_URL}/Fotos_profesores/default.png`)}
              style={{
                width: 110,
                height: 110,
                borderRadius: "50%",
                border: `4px solid ${colorPrincipal}`,
                objectFit: "cover",
                display: "block",
                margin: "0 auto 14px",
              }}
            />
            <h2 className="reserva-nombre-doc" style={{ color: colorPrincipal, fontSize: 18, margin: "0 0 4px" }}>{profesor.nombre}</h2>
            <p className="reserva-email-doc" style={{ color: "#475569", fontSize: 13, margin: 0 }}>{profesor.email}</p>

            <div className="reserva-resumen" style={{ marginTop: 18, textAlign: "left", fontSize: 13, color: "#334155" }}>
              <p><strong>{t("portal_tipo_servicio")}</strong> {servicioActual?.nombre || "-"}</p>
              <p>
                <strong>{t("reserva_fecha")}</strong>{" "}
                {new Date(horarioSeleccionado.fecha).toLocaleDateString(localeIntl)}
              </p>
              <p>
                <strong>{t("reserva_hora")}</strong>{" "}
                {formatHora12(horarioSeleccionado.hora_inicio)} – {formatHora12(horarioSeleccionado.hora_fin)}
              </p>
            </div>
          </div>

          {/* COLUMNA DERECHA — formulario editable */}
          <div className="reserva-columna" style={{ flex: "1 1 340px", padding: 30, textAlign: "left" }}>
            <h3 className="reserva-titulo-form" style={{ color: colorPrincipal, marginTop: 0 }}>{t("portal_info_estudiante")}</h3>

            <label className="reserva-label">{t("portal_nombre_completo")}</label>
            <input className="reserva-input" value={alumno} onChange={(e) => setAlumno(e.target.value)} style={inputStyle} />

            <label className="reserva-label">{t("portal_grado_curso")}</label>
            <input className="reserva-input" value={grado} onChange={(e) => setGrado(e.target.value)} style={inputStyle} />

            <label className="reserva-label">{t("portal_comentario_opcional")}</label>
            <textarea
              className="reserva-input"
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
              style={{ ...inputStyle, height: 80 }}
            />

            <p className="reserva-nota" style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{t("portal_verificacion_nota")}</p>

            <motion.button
              className="reserva-btn"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={handleReserva}
              disabled={loading}
              style={{
                ...buttonStyle,
                width: "100%",
                backgroundColor: colorPrincipal,
                borderRadius: estilo.botonRadius,
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? t("reserva_confirmando") : t("reserva_confirmar_btn")}
            </motion.button>

            <motion.button
              className="reserva-btn"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={onVolver}
              style={{ ...buttonStyleGray, width: "100%", marginLeft: 0, marginTop: 10, borderRadius: estilo.botonRadius }}
            >
              {t("reserva_volver")}
            </motion.button>
          </div>
        </motion.div>

        <style>
          {`
            @media (max-width: 480px) {
              .reserva-dos-columnas {
                padding: 8px !important;
              }
              .reserva-columna {
                padding: 14px !important;
              }
              .reserva-avatar {
                width: 70px !important;
                height: 70px !important;
                margin-bottom: 8px !important;
              }
              .reserva-titulo-form {
                font-size: 15px !important;
                margin-bottom: 6px !important;
              }
              .reserva-label {
                font-size: 12px !important;
              }
              .reserva-input {
                padding: 7px 9px !important;
                margin-top: 3px !important;
                margin-bottom: 8px !important;
                font-size: 13px !important;
              }
              textarea.reserva-input {
                height: 55px !important;
              }
              .reserva-nota {
                font-size: 11px !important;
                margin-top: 2px !important;
              }
              .reserva-btn {
                margin-top: 10px !important;
                padding: 9px 20px !important;
                font-size: 13px !important;
              }
              .reserva-nombre-doc {
                font-size: 15px !important;
              }
              .reserva-email-doc {
                font-size: 12px !important;
              }
              .reserva-resumen {
                margin-top: 10px !important;
                font-size: 12px !important;
              }
              .reserva-resumen p {
                margin: 4px 0 !important;
              }
            }
          `}
        </style>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 25 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      style={{
        minHeight: "100vh",
        background: "transparent",
        fontFamily: "'Poppins', sans-serif",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 25,
      }}
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.35 }}
        style={{
          background: "#fff",
          borderRadius: estilo.cardRadius,
          padding: 30,
          width: "100%",
          maxWidth: 500,
          boxShadow: estilo.key === "minimalista" ? "0 4px 14px rgba(0,0,0,0.08)" : "0 18px 40px rgba(0,0,0,0.18)",
          border: estilo.key === "minimalista" ? estilo.cardBorder : "none",
          textAlign: "center",
        }}
      >
        <motion.img
          src={profesor.foto}
          alt={profesor.nombre}
          onError={(e) =>
            (e.currentTarget.src =
              `${API_URL}/Fotos_profesores/default.png`)
          }
          style={{
            width: 130,
            height: 130,
            borderRadius: "50%",
            border: `4px solid ${colorPrincipal}`,
            objectFit: "cover",
            display: "block",
            margin: "0 auto 14px",
          }}
        />

        <h2 style={{ color: colorPrincipal }}>{profesor.nombre}</h2>
        <p style={{ color: "#475569" }}>{profesor.email}</p>

        <hr style={{ margin: "20px 0" }} />

        <h3 style={{ color: colorPrincipal }}>{t("reserva_detalles_titulo")}</h3>

        <p>
          <strong>{t("reserva_fecha")}</strong>{" "}
          {new Date(horarioSeleccionado.fecha).toLocaleDateString(localeIntl)}
        </p>

        <p>
          <strong>{t("reserva_hora")}</strong>{" "}
          {formatHora12(horarioSeleccionado.hora_inicio)} –{" "}
          {formatHora12(horarioSeleccionado.hora_fin)}
        </p>

        <div style={{ textAlign: "left", marginTop: 18 }}>
          <label>{t("reserva_nombre_alumno_label")}</label>
          <input value={alumno} onChange={(e) => setAlumno(e.target.value)} style={inputStyle} />

          <label>{t("reserva_grado_label")}</label>
          <input value={grado} onChange={(e) => setGrado(e.target.value)} style={inputStyle} />

          <label>{t("reserva_comentario_label")}</label>
          <textarea
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
            style={{ ...inputStyle, height: 80 }}
          />
        </div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleReserva}
          disabled={loading}
          style={
            estilo.botonEstilo === "outline"
              ? {
                  ...buttonStyle,
                  background: "white",
                  color: colorPrincipal,
                  border: `2px solid ${colorPrincipal}`,
                  borderRadius: estilo.botonRadius,
                  opacity: loading ? 0.7 : 1,
                }
              : {
                  ...buttonStyle,
                  backgroundColor: colorPrincipal,
                  borderRadius: estilo.botonRadius,
                  opacity: loading ? 0.7 : 1,
                }
          }
        >
          {loading ? t("reserva_confirmando") : t("reserva_confirmar_btn")}
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onVolver}
          style={{ ...buttonStyleGray, borderRadius: estilo.botonRadius }}
        >
          {t("reserva_volver")}
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  marginTop: 6,
  marginBottom: 14,
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  fontSize: 14,
};

const buttonStyle = {
  marginTop: 20,
  padding: "12px 26px",
  color: "white",
  border: "none",
  borderRadius: 14,
  cursor: "pointer",
  fontSize: 14,
};

const buttonStyleGray = {
  marginTop: 10,
  marginLeft: 10,
  padding: "12px 26px",
  backgroundColor: "#64748b",
  color: "white",
  border: "none",
  borderRadius: 14,
  cursor: "pointer",
  fontSize: 14,
};

export default ReservaCita;